import img_1 from '../../../assets/img/img_1.jpg';
import img_2 from '../../../assets/img/img_2.jpg';
import img_3 from '../../../assets/img/img_3.jpg';
import img_4 from '../../../assets/img/img_4.jpg';

export const reviewsData = [
  {
    id: 'rv1',
    name: 'Zorea',
    rating: 4,
    review:
      'This is one of my favorite restaurants in Chicago. I have been here over 20 times. My friend and I always come to eat.',
    image: img_1,
    location: 'Uptown',
  },
  {
    id: 'rv2',
    name: 'Tina',
    rating: 5,
    review:
      'The place itself is beautiful and very clean. Great place if you want sushi but are also looking for hearty Chinese food.',
    image: img_2,
    location: 'Albany',
  },
  {
    id: 'rv3',
    name: 'Ashley',
    rating: 5,
    review:
      'Lovely place,hostesses were very welcoming and let us know ahead of time that there would be some delays in service.',
    image: img_3,
    location: 'Bronzeville',
  },
  {
    id: 'rv4',
    name: 'Hunt',
    rating: 3,
    review:
      'I have been here two times now, and I plan on going back. The inside decor is just beautiful and such a great place for a date.',
    image: img_4,
    location: 'Pullman',
  },
];
